import { render, staticRenderFns } from "./ByPrincipleUsLogo.vue?vue&type=template&id=5f77f552&scoped=true"
import script from "./ByPrincipleUsLogo.vue?vue&type=script&lang=ts"
export * from "./ByPrincipleUsLogo.vue?vue&type=script&lang=ts"
import style0 from "./ByPrincipleUsLogo.vue?vue&type=style&index=0&id=5f77f552&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f77f552",
  null
  
)

export default component.exports